import CommonTable from "@/components/commonTable";
import { calibrateAxDmsCameraRequest } from "@/service/calibrate";
import { useTable } from "@/utils/useTable";
import { useMemo } from "react";
import { renderAnXingCalibrationStatus } from "./status";

interface CalibrateTableAxDmsCameraProps {
    diagnosisSearchParams: any;
    carId?: number
}


const CalibrateTableAxDmsCamera = (props: CalibrateTableAxDmsCameraProps) => {
    const { diagnosisSearchParams = {}, carId } = props;

    const searchParams = useMemo(() => {
        const _params = {
            ...diagnosisSearchParams
        }
        if (carId) {
            _params.carId = carId;
        }
        return _params;
    }, [diagnosisSearchParams, carId]);

    const { page, limit, loading, data, totalCount, onPageChange } = useTable({
        requestFunc: calibrateAxDmsCameraRequest,
        initRequest: true,
        initPageSize: 40,
        searchParams
    });

    const columns = [
        {
            title: '上报时间',
            dataIndex: 'reportTime'
        },
        {
            title: '参数版本号',
            dataIndex: 'version'
        },
        {
            title: '标定状态',
            dataIndex: 'success',
            render: renderAnXingCalibrationStatus
        },
        {
            title: 'headPitch',
            dataIndex: 'headPitch'
        },
        {
            title: 'headYaw',
            dataIndex: 'headYaw'
        },
        {
            title: 'headRoll',
            dataIndex: 'headRoll'
        },
        {
            title: 'gazePitch',
            dataIndex: 'gazePitch'
        },
        {
            title: 'gazeYaw',
            dataIndex: 'gazeYaw'
        },
    ];

    return (
        <CommonTable
            rowKey="id"
            columns={columns}
            dataSource={data}
            pagination={{
                total: totalCount,
                current: page,
                pageSize: limit,
                onChange: onPageChange
            }}
            bordered
            loading={loading}
            scroll={{ x: '100%', y: 400 }}
        />
    );
};

export default CalibrateTableAxDmsCamera;
